export default __webpack_public_path__ + "static/media/call.f9ec5102.svg";